module.exports = __webpack_public_path__ + "static/img/area01.1983eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/area01.png
// module id = um1u
// module chunks = 3